import axios from "axios";
import { logError } from "@/lib/errorCapture";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sc_admin_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && window.location.pathname.startsWith("/admin")) {
      localStorage.removeItem("sc_admin_token");
      if (!window.location.pathname.endsWith("/admin/login")) {
        window.location.href = "/admin/login";
      }
    }
    // Log everything that's NOT a routine 401 redirect or a successful response.
    // 401s on /admin/login are user-input errors (wrong password) — skip those.
    const status = err?.response?.status;
    const url = err?.config?.url;
    const isLoginAttempt = status === 401 && url && url.includes("/admin/login");
    if (!isLoginAttempt) {
      try {
        const method = (err?.config?.method || "GET").toUpperCase();
        const baseURL = err?.config?.baseURL || "";
        const endpoint = url ? `${baseURL}${url}` : null;
        // Network errors (no response) come through as "Network Error"
        const isNetwork = !err?.response;
        const message = isNetwork
          ? `Network error: ${method} ${endpoint || "(unknown)"}`
          : `${status} on ${method} ${endpoint || "(unknown)"}: ${err?.response?.data?.detail || err.message}`;
        logError({
          severity: isNetwork || (status && status >= 500) ? "error" : "warning",
          source: "xhr",
          message,
          http_method: method,
          http_status: status || null,
          endpoint,
        });
      } catch {
        /* never let logging break error flow */
      }
    }
    return Promise.reject(err);
  }
);

export default api;
